import React, { ChangeEventHandler, FC } from "react"
import clsx from "clsx"

export interface RadioInputProps {
  onChange: ChangeEventHandler
  name?: string
  id: any
  value: any
  fieldValue: any
  className?: string
  labelClassName?: string
  children: any
}

export const RadioInput: FC<RadioInputProps> = ({
  onChange,
  id,
  name,
  value,
  className,
  labelClassName,
  fieldValue,
  children,
}) => {
  return (
    <div className={clsx("radio-wrapper", className)}>
      {" "}
      <input
        type="radio"
        name={name}
        id={id}
        value={value}
        onChange={onChange}
        checked={fieldValue === value}
      />
      <label htmlFor={id} onClick={() => onChange} className={labelClassName}>
        {children}
      </label>
    </div>
  )
}
